import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { OnboardingMicroMerchantStatus } from 'micro-merchant/services/micro-merchant-service';
import { OnboardingStatusData } from './types';

import { RootState } from '../store';

const initialState: OnboardingStatusData = {};

export const globalSlice = createSlice({
  name: 'micro-merchant',
  initialState,
  reducers: {
    resetStore: (state) => {
      state = initialState;
      return state;
    },
    setOnboardingStatus: (
      state,
      action: PayloadAction<OnboardingMicroMerchantStatus | undefined>,
    ) => {
      state.microMerchantInfo = action.payload;
    },
  },
});

// selectors
const getMicroMerchantState = (state: RootState): OnboardingStatusData => state.microMerchant;

export const getOnboardingStatus = createSelector(
  getMicroMerchantState,
  (microMerchant) => microMerchant.microMerchantInfo,
);

const { actions, reducer } = globalSlice;

export const { resetStore: depositReset, setOnboardingStatus } = actions;

export default reducer;
